export default __webpack_public_path__ + "static/media/redtiger.52e9288e.png";